import { render, staticRenderFns } from "./Needjc.vue?vue&type=template&id=e4a4ee98&scoped=true"
import script from "./Needjc.vue?vue&type=script&lang=js"
export * from "./Needjc.vue?vue&type=script&lang=js"
import style0 from "./Needjc.vue?vue&type=style&index=0&id=e4a4ee98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a4ee98",
  null
  
)

export default component.exports